// extracted by mini-css-extract-plugin
module.exports = {"container":"a2","centerMenu":"a3","mainPanel":"a4","actions":"a5","logo":"a6"};